import { render, staticRenderFns } from "./cervix.vue?vue&type=template&id=b3e22566&scoped=true"
import script from "./cervix.vue?vue&type=script&lang=js"
export * from "./cervix.vue?vue&type=script&lang=js"
import style0 from "./cervix.vue?vue&type=style&index=0&id=b3e22566&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e22566",
  null
  
)

export default component.exports